import { Button } from '@iwoca/orion';

import { useEcomPostMessage } from '../../hooks/useEcomPostMessage';
import { useIsOverlay } from '../../hooks/useIsOverlay';
import { useGetPaymentStatus } from '../useGetPaymentStatus';
import { usePaymentId } from '../usePaymentId';

export const ReturnToSellerCTA = () => {
  const paymentId = usePaymentId();
  const { paymentData } = useGetPaymentStatus(paymentId);
  const redirectUrl = paymentData?.order?.redirect_url || '';

  const isFailure = paymentData?.status === 'failed';
  const isOverlay = useIsOverlay({ payNow: true });

  useEcomPostMessage({
    enabled: isFailure && isOverlay,
    status: 'UNSUCCESSFUL',
    redirectUrl,
  });

  const handleClick = () => {
    if (isOverlay) {
      window.close();
      return;
    }

    window.location.href = redirectUrl;
  };

  return (
    <Button
      onClick={handleClick}
      className="my-m flex !h-max w-full flex-col !gap-0"
    >
      Return to {paymentData?.seller_trading_name}
      <br />
      {isFailure && <div>and try again</div>}
    </Button>
  );
};
